module.exports = __webpack_public_path__ + "img/victron_20A.f5bcc218.png";